<template>
<el-popover placement="bottom-start" width="310" trigger="click" :value="visible" @show="visible = true">
    <el-form :model="filterForm" ref="filterForm">
        <el-form-item size="small" prop="brand" label="Brand">
            <el-select v-model="filterForm.brand" placeholder="Select Brand" style="width:100%;">
                <el-option v-for="(brand, index) in brandOptions" :key="index" :label="brand.brand" :value="brand.searchTerm"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item size="small" prop="startDate" label="Date After">
            <el-date-picker v-model="filterForm.dateRange.startDate" clearable format="MM/dd/yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Select Date After" style="width:100%;"></el-date-picker>
        </el-form-item>

        <el-form-item size="small" prop="endDate" label="Date Before" style="width:100%;">
            <el-date-picker v-model="filterForm.dateRange.endDate" clearable format="MM/dd/yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Select Date Before" style="width:100%;"></el-date-picker>
        </el-form-item>

        <el-form-item size="small" prop="search" label="Search">
            <el-input v-model="filterForm.search" clearable placeholder="Enter keyword" style="width:100%;"></el-input>
        </el-form-item>

        <el-form-item>
            <el-button size="small" type="danger" plain @click="handleClearFilter">Clear</el-button>
            <div style="float: right;">
                <el-button size="small" type="primary" @click="handleFilter" style="width:8em">Filter</el-button>
            </div>
        </el-form-item>
    </el-form>
    <el-button size="small" type="primary" slot="reference" icon="mdi mdi-filter-menu"> Filter</el-button>
</el-popover>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import {
    brandinfo
} from '../../../services/excelGeneratorSvc'
import * as type from '@/store/types';
import {
    bus
} from '@/main';
import moment from 'moment'
export default {
    data() {
        return {
            visible: false,
            filterForm: {
                sender: 'inbound@b2bgateway.org',
                brand: 'Altra',
                dateRange: {
                    startDate: moment(new Date()).utcOffset('+08:00').format('YYYY-MM-DD'),
                    endDate: null
                },
                search: ''
            },
            // brandOptions: brandinfo
        }
    },
    computed: {
        ...mapGetters({
            brandOptions: `ediInvoice/getBrands`
        })
    },
    created() {
        bus.$on('clearUploadHistoryFilter', this.handleClearFilter)
        this.handleFilter();
        this.loadBrands()
    },
    methods: {
        ...mapActions({
           loadBrands: `ediInvoice/${type.EDI_GET_BRANDS}` 
        }),
        handleFilter() {
            this.visible = false;
            this.$emit('onFilter', this.filterForm)
        },
        handleClearFilter() {
            this.$refs.filterForm.resetFields();
            this.visible = false;
        }
    }
}
</script>
